import { PartnerConfig } from '@/types'
import DEFAULT from './premadeConfigs'
import {
  pdtTest,
  usaTest,
  babylon,
  bupa,
  c1cx,
  c2cx,
  centeneCaliforniaHealthAndWellness,
  centeneCaliforniaHealthNetCommercial,
  centeneCaliforniaHealthNetMediCal,
  centeneIowaTotalCare,
  centeneIowaTotalCareMedicaidVbc,
  centeneMissouriHomeStateHealth,
  centeneMissouriHomeStateHealthVbc,
  centeneMissouriHomeStateHealthVbcV2,
  centeneMississippiMagnoliaMedicaidVbcV2,
  agentHshV2,
  centeneNevadaSilverSummit,
  centeneGeorgiaPeachStateMedicaidVbc,
  centeneMississippiMagnoliaMedicaidVbc,
  nebraskaAmbetterTotalCareVbc,
  indianaAmbetterVirtualAccessVbc,
  newHampshireAmbetterVirtualAccessVbc,
  ohioAmbetterVirtualAccessVbc,
  georgiaAmbetterVirtualAccessVbc,
  missouriAmbetterVirtualAccessVbc,
  babylonUs,
  babylonUsInternalTexasVbc,
  fidelisCareNewYork,
  babylonCanadaB2g,
  calviva,
  mshpNewYork,
  agentHsh,
  fidelisNyMedicaid,
  fidelis360,
  californiaMeritageCommercialFfs,
  californiaMeritageMediCalFfs,
  californiaMeritageMedicareAdvantageFfs,
  newMexicoPhsMaB360,
  newMexicoPhsUfB360,
  fidelisNyMedicaidV2,
  centeneGeorgiaPeachStateMedicaidVbcV2,
  centeneIowaTotalCareMedicaidVbcV2,
  newMexicoPhsMaB360V2,
  babylonUsV2,
  babylonUsInternalTexasVbcV2,
  centeneCaliforniaHealthAndWelnnessV2,
  centeneCaliforniaHealthNetCommercialV2,
  centeneCaliforniaHealthNetMediCalV2,
  centeneIowaTotalCareV2,
  centeneNevadaSilverSummitV2,
  nebraskaAmbetterTotalCareVbcV2,
  fidelisCareNewYorkV2,
  fidelis360V2,
  mshpNewYorkV2,
  calvivaV2,
  bcbsNewMexicoComV2,
  bcbsNewMexicoMedV2,
  californiaMeritageCommercialFfsV2,
  californiaMeritageMediCalFfsV2,
  californiaMeritageMedicareAdvantageFfsV2,
  centeneMissouriHomeStateHealthV2,
  georgiaAmbetterVirtualAccessVbcV2,
  indianaAmbetterVirtualAccessVbcV2,
  newHampshireAmbetterVirtualAccessVbcV2,
  ohioAmbetterVirtualAccessVbcV2,
  missouriAmbetterVirtualAccessVbcV2,
  newMexicoPhsUfB360V2,
} from './partnerConfigs'

const partnerConfig: { [key: string]: PartnerConfig | PartnerConfig[] } = {
  // DO NOT MODIFY OR REMOVE! Required for regression tests.
  // Or, face the consequences. Mwahahahaha! <insert other types of evil laugh>!
  regressionTestFullFlow: DEFAULT.TESTS.FULL_CONFIG_FLOW(),
  regressionTestFullFlowV2: DEFAULT.TESTS.FULL_CONFIG_FLOW_V2(),
  regressionTestFullFlowFastTrack: DEFAULT.TESTS.FULL_CONFIG_FLOW_FAST_TRACK(),
  regressionTestMinimumFlow: DEFAULT.TESTS.MINIMUM_CONFIG_FLOW(),
  regressionTestMinimumFlowV2: DEFAULT.TESTS.MINIMUM_CONFIG_FLOW_V2(),
  // END OF TEST PARTNERS

  /* DEVELOPMENT FLOWS */
  pdtTest,
  usaTest,

  /* REAL PARTNER FLOWS */
  // GBR
  babylon,
  bupa,
  c1cx,
  c2cx,

  // USA
  babylonUs,
  babylonUsInternalTexasVbc,
  centeneCaliforniaHealthAndWellness,
  centeneCaliforniaHealthNetCommercial,
  centeneCaliforniaHealthNetMediCal,
  centeneIowaTotalCare,
  centeneIowaTotalCareMedicaidVbc,
  centeneMissouriHomeStateHealth,
  centeneMissouriHomeStateHealthVbc,
  centeneNevadaSilverSummit,
  centeneGeorgiaPeachStateMedicaidVbc,
  centeneMississippiMagnoliaMedicaidVbc,
  nebraskaAmbetterTotalCareVbc,
  indianaAmbetterVirtualAccessVbc,
  newHampshireAmbetterVirtualAccessVbc,
  ohioAmbetterVirtualAccessVbc,
  georgiaAmbetterVirtualAccessVbc,
  missouriAmbetterVirtualAccessVbc,
  fidelisCareNewYork,
  fidelisNyMedicaid,
  fidelis360,
  mshpNewYork,
  calviva,
  bcbsNewMexicoComV2,
  bcbsNewMexicoMedV2,
  californiaMeritageCommercialFfs,
  californiaMeritageMediCalFfs,
  californiaMeritageMedicareAdvantageFfs,
  newMexicoPhsMaB360,
  newMexicoPhsUfB360,

  // USA - Agent
  agentHsh,

  // CAN
  babylonCanadaB2g,
}

export const getPartnerConfigs = (isAccountCreationV2?: boolean) => {
  if (isAccountCreationV2) {
    return {
      ...partnerConfig,
      babylonUs: babylonUsV2,
      babylonUsInternalTexasVbc: babylonUsInternalTexasVbcV2,
      centeneCaliforniaHealthAndWellness: centeneCaliforniaHealthAndWelnnessV2,
      centeneCaliforniaHealthNetCommercial: centeneCaliforniaHealthNetCommercialV2,
      centeneCaliforniaHealthNetMediCal: centeneCaliforniaHealthNetMediCalV2,
      centeneIowaTotalCare: centeneIowaTotalCareV2,
      centeneIowaTotalCareMedicaidVbc: centeneIowaTotalCareMedicaidVbcV2,
      centeneMissouriHomeStateHealth: centeneMissouriHomeStateHealthV2,
      centeneMissouriHomeStateHealthVbc: centeneMissouriHomeStateHealthVbcV2,
      centeneNevadaSilverSummit: centeneNevadaSilverSummitV2,
      centeneGeorgiaPeachStateMedicaidVbc: centeneGeorgiaPeachStateMedicaidVbcV2,
      centeneMississippiMagnoliaMedicaidVbc: centeneMississippiMagnoliaMedicaidVbcV2,
      nebraskaAmbetterTotalCareVbc: nebraskaAmbetterTotalCareVbcV2,
      fidelisCareNewYork: fidelisCareNewYorkV2,
      fidelisNyMedicaid: fidelisNyMedicaidV2,
      fidelis360: fidelis360V2,
      mshpNewYork: mshpNewYorkV2,
      calviva: calvivaV2,
      californiaMeritageCommercialFfs: californiaMeritageCommercialFfsV2,
      californiaMeritageMediCalFfs: californiaMeritageMediCalFfsV2,
      californiaMeritageMedicareAdvantageFfs: californiaMeritageMedicareAdvantageFfsV2,
      newMexicoPhsMaB360: newMexicoPhsMaB360V2,
      georgiaAmbetterVirtualAccessVbc: georgiaAmbetterVirtualAccessVbcV2,
      agentHsh: agentHshV2,
      indianaAmbetterVirtualAccessVbc: indianaAmbetterVirtualAccessVbcV2,
      newHampshireAmbetterVirtualAccessVbc: newHampshireAmbetterVirtualAccessVbcV2,
      ohioAmbetterVirtualAccessVbc: ohioAmbetterVirtualAccessVbcV2,
      missouriAmbetterVirtualAccessVbc: missouriAmbetterVirtualAccessVbcV2,
      newMexicoPhsUfB360: newMexicoPhsUfB360V2,
    }
  }

  return partnerConfig
}

export default partnerConfig
